import { DISABLE_MONTHLY_ULTIMATE } from "src/data/variables";

const TitlePlans = () => {
  return (
    <div className="flex w-full items-end justify-center mt-20">
      <div className="flex w-[1228px]">
        <div className="flex mr-10 items-center">
          <p className="flex bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text text-6xl font-bold">
            Compare<span className="flex text-white ml-2"> Plans </span>
          </p>
        </div>
        <div className="flex flex-col mt-2 ml-20">
          <p className="flex text-[26px] font-bold">Free</p>
          <p className="flex text-[16px] -mt-4 font-extralight text-slate-300 opacity-75">
            Its free forever
          </p>
        </div>
        <div className="flex flex-col mt-2 ml-40">
          <p className="flex text-[26px] font-bold text-brand-blue">Premium</p>
          <p className="flex text-[16px] -mt-4 font-extralight text-slate-300 opacity-75">
            Starting @ $95.88 Yearly
          </p>
        </div>
        <div className="flex flex-col mt-2 ml-24">
          <p className="flex text-[26px] font-bold text-brand-purple">Ultimate</p>
          <p className="flex text-[16px] -mt-4 font-extralight text-slate-300 opacity-75">
            {DISABLE_MONTHLY_ULTIMATE ? "Starting @ $179.88 Yearly" : "Starting @ $75/monthly"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TitlePlans;
